import { Button, Grid, Group, Layout, Page } from "@/comn/components";
import { comnEnvs, comnUtils } from "@/comn/utils";
import { useFetch, useForm, useGrid, useModal, usePage, useResource, useStore, useToast } from "@/comn/hooks";
import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import {
    BASE,
    APIS,
    URLS,
    SF_PRE_VRFN_DOC_SRCH,
    SG_VRFN_TRGT_DOC_LIST,
    SG_COMN_VRFN_CTRA_LIST,
    SF_COMN_VRFN_CTRA_SRCH,
} from "@/tra/tancis/ptli/comnmdle/doc/services/PtliDocMgmtService";

/*
 * Pre-Verification Management by Document List
 * !== 문서별 사전검증 관리 목록 ==!
 */
export const PTLI0413001Q = () => {
    useResource({
        defaultSchema: [
            { area: "comnCd", comnCd: "COM0011" },
            { area: "comnCd", comnCd: "COM0024" },
        ],
    });

    /*
     * Declaration Hook, Meta
     * !== Hook, 메타 정보 정의 ==!
     */
    const { pgeUid, menuId } = usePage({
        auth: ["auth_ptli0015", "auth_ptlianyADM"],
    });
    const { t } = useTranslation();
    const modal = useModal();
    const navigate = useNavigate();
    const { pgeStore, setStore, getStore } = useStore({ pgeUid: pgeUid });
    const toast = useToast(); // Toast Message Hook !== Toast 메세지 표시 Hook ==!

    const form = {
        preVrfnDocSrch: useForm({
            defaultSchema: SF_PRE_VRFN_DOC_SRCH,
            defaultValues: { ...pgeStore?.form },
        }),
        comnVrfnCtraSrch: useForm({
            defaultSchema: SF_COMN_VRFN_CTRA_SRCH,
            defaultValues: { ...pgeStore?.formCtra },
        }),
    };

    const grid = {
        vrfnTrgtDocList: useGrid({
            defaultSchema: SG_VRFN_TRGT_DOC_LIST,
            page: pgeStore?.page,
            size: pgeStore?.size,
        }),
        comnVrfnCtraList: useGrid({
            defaultSchema: SG_COMN_VRFN_CTRA_LIST,
            page: pgeStore?.pageCtra,
            size: pgeStore?.sizeCtra,
        }),
    };

    const fetch = {
        getVrfnTrgtDocList: useFetch({
            api: (page = grid.vrfnTrgtDocList.page) =>
                APIS.getVrfnTrgtDocList(form.preVrfnDocSrch.getValues(), page, grid.vrfnTrgtDocList.size),
            enabled: comnUtils.isEmpty(form.preVrfnDocSrch.errors),
            key: [grid.vrfnTrgtDocList.page, grid.vrfnTrgtDocList.size],
            onSuccess: () => {
                setStore(pgeUid, {
                    form: form.preVrfnDocSrch.getValues(),
                    page: grid.vrfnTrgtDocList.page,
                    size: grid.vrfnTrgtDocList.size,
                });
            },
            onError: () => toast.showToast({ type: "error", content: "msg.com.00025" }), // Failed to select. !== 조회가 실패하였습니다. ==!
        }),
        getComnVrfnCtraList: useFetch({
            api: (page = grid.comnVrfnCtraList.page) =>
                APIS.getComnVrfnCtraList(form.comnVrfnCtraSrch.getValues(), page, grid.comnVrfnCtraList.size),
            enabled: !comnUtils.isEmpty(form.comnVrfnCtraSrch.getValue("dclaDocCd")),
            key: [grid.comnVrfnCtraList.page, grid.comnVrfnCtraList.size],
            onSuccess: () => {
                setStore(pgeUid, {
                    ...getStore(pgeUid),
                    formCtra: form.comnVrfnCtraSrch.getValues(),
                    pageCtra: grid.comnVrfnCtraList.page,
                    sizeCtra: grid.comnVrfnCtraList.size,
                });
            },
            onError: () => toast.showToast({ type: "error", content: "msg.com.00025" }), // Failed to select. !== 조회가 실패하였습니다. ==!
        }),
    };

    const render = {
        cell: {
            dclaDocCd: (props: any) => {
                const { rowValues, value } = props;
                return (
                    <Link
                        to={`?menuId=${menuId}`}
                        onClick={() => {
                            handler.setComnVrfnCtraSrch(`${rowValues.dclaDocCd}`, `${rowValues.docNm}`);
                            handler.getComnVrfnCtraList();
                        }}
                    >
                        {value}
                    </Link>
                );
            },
        },
    };

    const renderCtra = {
        cell: {
            trgtColNm: (props: any) => {
                const { rowValues, value } = props;
                return (
                    <Link
                        to={`${URLS.ptli0413003s}/${rowValues.dclaDocCd}-${rowValues.trgtTbNm}-${rowValues.trgtColNm}?menuId=${menuId}`}
                    >
                        {value}
                    </Link>
                );
            },
        },
    };

    const handler = {
        getVrfnTrgtDocList: () => {
            grid.vrfnTrgtDocList.setPage(0);
            fetch.getVrfnTrgtDocList.fetch(0);
        },
        setComnVrfnCtraSrch: (dclaDocCd: any, docNm: any) => {
            form.comnVrfnCtraSrch.setValue("dclaDocCd", dclaDocCd);
            form.comnVrfnCtraSrch.setValue("docNm", docNm);
        },
        getComnVrfnCtraList: () => {
            grid.comnVrfnCtraList.setPage(0);
            fetch.getComnVrfnCtraList.fetch(0);
        },
        click_Btn_Btch: () => {
            modal.openModal({
                url: URLS.ptli0413004s,
                params: {
                    dclaDocCd: form.comnVrfnCtraSrch.getValue("dclaDocCd"),
                },
                size: "md",
                draggable: true,
                callback: (data) => {
                    if (data.pgeUid === "ptli0413004s") {
                        modal.closeModal();
                    }
                    handler.getComnVrfnCtraList();
                },
            });
        },
        click_Btn_New: () => {
            navigate(`${URLS.ptli0413002s}/${form.comnVrfnCtraSrch.getValue("dclaDocCd")}?menuId=${menuId}`);
        },
    };

    useEffect(() => {
        handler.getVrfnTrgtDocList();
        if (form.comnVrfnCtraSrch.getValue("dclaDocCd")) {
            handler.getComnVrfnCtraList();
        }
    }, []);

    const dclaDocCd = form.comnVrfnCtraSrch.getValue("dclaDocCd") == undefined;

    return (
        <Page>
            <Group>
                <Group.Body>
                    <Group.Section>
                        <Group.Row>
                            <Group.Control {...form.preVrfnDocSrch.schema.bsopClsfCd} />
                            <Group.Control {...form.preVrfnDocSrch.schema.dclaDocCd} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.preVrfnDocSrch.schema.docNm} />
                        </Group.Row>
                    </Group.Section>
                    <Layout>
                        <Layout.Left>
                            <Button role={"reset"} onClick={() => form.preVrfnDocSrch.reset()} />
                        </Layout.Left>
                        <Layout.Right>
                            <Button role={"search"} onClick={() => handler.getVrfnTrgtDocList()} />
                        </Layout.Right>
                    </Layout>
                </Group.Body>
            </Group>
            <Group>
                <Group.Body>
                    <Group.Title title={t("T_VRFN_TRGT_DOC_LIST")} titleSize={2}></Group.Title>
                    <Group.Section>
                        <Grid
                            {...grid.vrfnTrgtDocList.grid}
                            data={fetch.getVrfnTrgtDocList.data?.vrfnTrgtDocList}
                            render={render}
                        />
                    </Group.Section>
                </Group.Body>
            </Group>
            <Group>
                <Group.Body>
                    <Layout>
                        <Group.Title title={t("T_COMN_VRFN_CTRA_LIST")} titleSize={2}></Group.Title>
                        <Layout.Right>
                            <Button
                                variant="outline-primary"
                                disabled={dclaDocCd}
                                onClick={() => handler.click_Btn_Btch()}
                            >
                                {t("B_ITM_BTCH_RGSR")}
                            </Button>
                        </Layout.Right>
                    </Layout>
                    <Group.Section>
                        <Grid
                            {...grid.comnVrfnCtraList.grid}
                            data={fetch.getComnVrfnCtraList.data?.comnVrfnCtraList}
                            render={renderCtra}
                        />
                    </Group.Section>
                </Group.Body>
            </Group>
            <Layout direction="row">
                <Layout.Button role="new" disabled={dclaDocCd} onClick={() => handler.click_Btn_New()}></Layout.Button>
            </Layout>
        </Page>
    );
};
